import React from "react";
import DefaultQuestionBody from "./DefaultQuestionBody";

const TextComponent = () => <DefaultQuestionBody />;

TextComponent.information = {
	type: "text",
	name: "Text"
};

export default TextComponent;
